export default __webpack_public_path__ + "static/media/air-controller-asset.1ce1f622.svg";